import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isSubscriptionGroup = objectOf({
  id: string,
  name: string,
  description: string,
  external_id: string,
});

export const isSubscriptionGroupPayload = arrayOf(isSubscriptionGroup);
